// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2uyDc","detailsBorder":"styles_detailsBorder__2PjWh"};